var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('CondoFeeTable',{attrs:{"isLoadingData":_vm.isLoadingData,"condominiumFees":_vm.condominiumFees},on:{"get-condominal-fees":_vm.getCondominalFees}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }